import {
  commissionCalcul,
  ElevesCommandesStatus
} from '../commission/commission';
import {
  Enum_Classe_Ong,
  Enum_Userspermissionsuser_Ong,
  Enum_Commande_Status
} from '../../graphql/generated/graphql';
import { NgoListWithInfos } from './ngoDescription';

const FC_CONTRIBUTION = 0.005;

const NGO_LIST = {
  Planete_urgence: {
    name: Enum_Classe_Ong.PlaneteUrgence,
    displayName: 'Planète Urgence',
    studentSlogan: "J'agis pour la planète",
    classSlogan: 'La classe agi pour la planète',
    equivalence: 1
  },
  Un_enfant_par_la_main: {
    name: Enum_Classe_Ong.UnEnfantParLaMain,
    displayName: 'Un enfant Par la main',
    studentSlogan: "J'agis pour les enfants",
    classSlogan: 'La classe agi pour les enfants',
    equivalence: 1
  },
  Societe_protectrice_des_animaux: {
    name: Enum_Classe_Ong.SocieteProtectriceDesAnimaux,
    displayName: 'Société Protectrice des Animaux',
    studentSlogan: "J'agis pour les animaux",
    classSlogan: 'La classe agi pour les animaux',
    equivalence: 1
  }
};

export const getStudentNgoSlogan = ngo => NGO_LIST[ngo].studentSlogan;
export const getClassNgoSlogan = ngo => NGO_LIST[ngo].classSlogan;

export const calculationOfFCContribution = (ca: number): number => {
  if (ca < 0) return 0;
  const res: number = ca * FC_CONTRIBUTION;
  return Number(res.toFixed(2));
};

export const getNgoContributionFromAllStudents = studentsOrders => {
  return Number(
    studentsOrders
      .map(order => {
        const payedOrders = order.commandes.filter(
          commande => commande.status === Enum_Commande_Status.Paye
        );
        return { commandes: payedOrders, qteca: order.qteca };
      })
      .filter(order => order.commandes.length > 0)
      .reduce((total, order) => {
        const numberOfOrdersWithNgoContribution = order.commandes.filter(
          commande => commande.customerContributedToTheOng
        ).length;
        return total + numberOfOrdersWithNgoContribution;
      }, 0)
  );
};

export const getAmountDedicatedToNgoForClass = (
  caClasse: number,
  studentsOrders: ElevesCommandesStatus[],
  percentOfCommissionDedicatedToNgo: number,
  ngo: string
): {
  percentOfCommissionDedicatedToNgo: number;
  total: number;
  studentsEngagement: number;
  ngoName: string;
  numberOfOrdersWithCustomerContribution: number;
  totalDonatedToNgo: number;
} => {
  const { commission } = commissionCalcul(caClasse, studentsOrders);
  const totalStudent = studentsOrders.length;
  const studentWithOrdersWithCustomerContributedToOng = studentsOrders
    .map(student =>
      student.commandes.some(
        commande => commande.customerContributedToTheOng === true
      )
    )
    .filter(student => student === true).length;
  const total = Number(
    (commission * (percentOfCommissionDedicatedToNgo / 100)).toFixed(2)
  );
  const numberOfOrdersWithCustomerContribution = getNgoContributionFromAllStudents(
    studentsOrders
  );
  return {
    percentOfCommissionDedicatedToNgo,
    studentsEngagement: parseInt(
      (
        (studentWithOrdersWithCustomerContributedToOng / totalStudent) *
        100
      ).toFixed()
    ),
    total,
    ngoName: ngo,
    numberOfOrdersWithCustomerContribution,
    totalDonatedToNgo:
      numberOfOrdersWithCustomerContribution +
      total +
      calculationOfFCContribution(caClasse)
  };
};

export const getAmountDedicatedToNgoForStudent = (
  ca: number,
  commandesWithContribution: Array<any>,
  commandes: Array<any>,
  ngo: Enum_Userspermissionsuser_Ong
): {
  total: number;
  contributionFC: number;
  customersContribution: number;
  customersEngagement;
  ngo;
} => {
  const contributionFC = calculationOfFCContribution(ca);
  const payedCommandesWithContribution = commandesWithContribution.filter(
    order => order.attributes.status === Enum_Commande_Status.Paye
  );
  const payedCommandes = commandes.filter(
    order => order.attributes.status === Enum_Commande_Status.Paye
  );
  const displayName = NgoListWithInfos.find(ong => ong.name === ngo)
    ?.displayName;
  return {
    total: contributionFC + commandesWithContribution.length,
    contributionFC,
    customersContribution: commandesWithContribution.length,
    customersEngagement:
      payedCommandes.length > 0
        ? (
            (payedCommandesWithContribution.length / payedCommandes.length) *
            100
          ).toFixed()
        : 0,
    ngo: displayName ? displayName : ''
  };
};

export const getNumberOfItemsAccordingAmountDedicatedToNgoAndNgo = (
  amountDedicatedToOng: number,
  ong: Enum_Userspermissionsuser_Ong
): number => {
  if (!ong) return 0;
  return Math.trunc(NGO_LIST[ong].equivalence * amountDedicatedToOng);
};

export const getRecapAboutNgoItems = (
  amountDedicatedToOng: number,
  ong: Enum_Userspermissionsuser_Ong
) => {
  const numberOfItems = getNumberOfItemsAccordingAmountDedicatedToNgoAndNgo(
    amountDedicatedToOng,
    ong
  );
  if (ong === Enum_Userspermissionsuser_Ong.SocieteProtectriceDesAnimaux)
    //to do
    return `journée${numberOfItems > 1 ? 's' : ''} de repas nutritionnel`;
  if (ong === Enum_Userspermissionsuser_Ong.PlaneteUrgence)
    return `arbre${numberOfItems > 1 ? 's' : ''} planté${
      numberOfItems > 1 ? 's' : ''
    }`;
  if (ong === Enum_Userspermissionsuser_Ong.UnEnfantParLaMain)
    return `jour${numberOfItems > 1 ? 's' : ''} de soutien accordé${
      numberOfItems > 1 ? 's' : ''
    }`;
  if (!ong) return 'Aucune ONG sélectionnée';
};

export const getRecapSentence = (ngoName, contribution) => {
  if (!ngoName && !contribution)
    return "Nous ne souhaitons pas reverser d'argent à une ONG";
  if (!ngoName)
    return `Nous souhaitons reverser ${contribution}% de la commission classe`;
  if (!contribution)
    return `Nous souhaitons contribuer pour l'ONG ${
      NgoListWithInfos.find(ngo => ngo.name === ngoName).displayName
    }`;
  return `Nous souhaitons reverser ${contribution}% à l'ONG ${
    NgoListWithInfos.find(ngo => ngo.name === ngoName).displayName
  }`;
};
